import React from 'react';
import {Field} from 'redux-form/immutable';
import {Card, Button} from 'antd'
import {TextField} from 'redux-form-antd'
import {
    required
} from "../validDesc";

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 4},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 20},
    },
};
const GuardianData = props => {
    const {changGuardianData} = props
    return (
        <Card title="監護人資料">

            <Button onClick={() => changGuardianData('moth')} size='large'
                    style={{width: '50%', marginBottom: '10px'}}>
                載入母親資料
            </Button>

            <Button onClick={() => changGuardianData('fath')} size='large'
                    style={{width: '50%', marginBottom: '10px'}}>
                載入父親資料
            </Button>

            <Field {...formItemLayout} validate={[required]} component={TextField} label="監護人姓名"
                   name="guardian_name" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="監護人公司電話"
                   name="guardian_phone" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="監護人行動電話"
                   name="guardian_hand_phone" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="監護人職業"
                   name="guardian_occupation" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="監護人服務單位"
                   name="guardian_unit" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="監護人職稱"
                   name="guardian_work_name" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="監護人電子信箱"
                   name="guardian_email" type="text"></Field>
        </Card>
    )
}
export default GuardianData


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/GuardianData.jsx